import KendraPluginTypes from './kendraPlugin.types';
import KendraPluginState from './kendraPlugin.state';

export type KendraPluginAction =
    | { type: typeof KendraPluginTypes.SET_KENDRA_PLUGIN_STATE, payload: KendraPluginState }

export function setKendraPluginState(kendraState: KendraPluginState): KendraPluginAction {
    return {
        type: KendraPluginTypes.SET_KENDRA_PLUGIN_STATE,
        payload: kendraState,
    }
}